import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-100 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-lg p-8">
        {/* 헤더 */}
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-slate-800 mb-2">개인정보처리방침</h1>
          <p className="text-slate-500 text-sm">GRK Workspace</p>
        </div>

        {/* 서문 */}
        <div className="mb-8 p-4 bg-slate-50 rounded-lg">
          <p className="text-slate-700 leading-relaxed">
            주식회사 지알케이컨설팅(이하 "회사")은 개인정보보호법에 따라 이용자의 개인정보를 보호하고
            이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보처리방침을 수립·공개합니다.
          </p>
        </div>

        {/* 섹션 1 */}
        <section className="mb-6">
          <h2 className="text-lg font-semibold text-slate-800 mb-3 flex items-center">
            <span className="w-6 h-6 bg-blue-500 text-white rounded-full text-sm flex items-center justify-center mr-2">1</span>
            수집하는 개인정보 항목
          </h2>
          <div className="ml-8 p-4 border border-slate-200 rounded-lg">
            <ul className="space-y-2 text-slate-600">
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>이름</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>이메일 주소</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>프로필 사진 (Google 계정 연동 시)</span>
              </li>
            </ul>
          </div>
        </section>

        {/* 섹션 2 */}
        <section className="mb-6">
          <h2 className="text-lg font-semibold text-slate-800 mb-3 flex items-center">
            <span className="w-6 h-6 bg-blue-500 text-white rounded-full text-sm flex items-center justify-center mr-2">2</span>
            개인정보 수집 목적
          </h2>
          <div className="ml-8 p-4 border border-slate-200 rounded-lg">
            <ul className="space-y-2 text-slate-600">
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>서비스 로그인 및 사용자 인증</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>직원 식별 및 권한 관리</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>서비스 이용 기록 관리</span>
              </li>
            </ul>
          </div>
        </section>

        {/* 섹션 3 */}
        <section className="mb-6">
          <h2 className="text-lg font-semibold text-slate-800 mb-3 flex items-center">
            <span className="w-6 h-6 bg-blue-500 text-white rounded-full text-sm flex items-center justify-center mr-2">3</span>
            개인정보 보유 및 이용 기간
          </h2>
          <div className="ml-8 p-4 border border-slate-200 rounded-lg">
            <ul className="space-y-2 text-slate-600">
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>회원 탈퇴 시 또는 퇴사 시까지</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>관련 법령에 따른 보존 기간 준수</span>
              </li>
            </ul>
          </div>
        </section>

        {/* 섹션 4 */}
        <section className="mb-6">
          <h2 className="text-lg font-semibold text-slate-800 mb-3 flex items-center">
            <span className="w-6 h-6 bg-blue-500 text-white rounded-full text-sm flex items-center justify-center mr-2">4</span>
            개인정보 제3자 제공
          </h2>
          <div className="ml-8 p-4 border border-slate-200 rounded-lg">
            <ul className="space-y-2 text-slate-600">
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>회사는 이용자의 개인정보를 제3자에게 제공하지 않습니다.</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>단, 법령에 의한 요청이 있는 경우 예외로 합니다.</span>
              </li>
            </ul>
          </div>
        </section>

        {/* 섹션 5 */}
        <section className="mb-6">
          <h2 className="text-lg font-semibold text-slate-800 mb-3 flex items-center">
            <span className="w-6 h-6 bg-blue-500 text-white rounded-full text-sm flex items-center justify-center mr-2">5</span>
            개인정보 보호책임자
          </h2>
          <div className="ml-8 p-4 border border-slate-200 rounded-lg">
            <ul className="space-y-2 text-slate-600">
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>담당부서: 관리팀</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>이메일: admin@grkcon.com</span>
              </li>
            </ul>
          </div>
        </section>

        {/* 섹션 6 */}
        <section className="mb-8">
          <h2 className="text-lg font-semibold text-slate-800 mb-3 flex items-center">
            <span className="w-6 h-6 bg-blue-500 text-white rounded-full text-sm flex items-center justify-center mr-2">6</span>
            개인정보처리방침 변경
          </h2>
          <div className="ml-8 p-4 border border-slate-200 rounded-lg">
            <p className="text-slate-600">
              이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우에는
              변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
            </p>
          </div>
        </section>

        {/* 시행일자 */}
        <div className="text-center text-slate-500 text-sm mb-8 p-4 bg-slate-50 rounded-lg">
          <p>본 방침은 <strong>2025년 1월 1일</strong>부터 시행됩니다.</p>
        </div>

        {/* 버튼 */}
        <div className="text-center">
          <button
            onClick={() => navigate('/login')}
            className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            로그인 페이지로 이동
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
